import { TaskPriority } from '../types/Task';

export const TASK_PRIORITY_VALUES: TaskPriority[] = [
  TaskPriority.LOW,
  TaskPriority.MEDIUM,
  TaskPriority.HIGH,
  TaskPriority.URGENT,
];

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  [TaskPriority.LOW]: 'Low',
  [TaskPriority.MEDIUM]: 'Medium',
  [TaskPriority.HIGH]: 'High',
  [TaskPriority.URGENT]: 'Urgent',
};

export const TASK_PRIORITY_SORT_ORDER: Record<TaskPriority, number> = {
  [TaskPriority.LOW]: 1,
  [TaskPriority.MEDIUM]: 2,
  [TaskPriority.HIGH]: 3,
  [TaskPriority.URGENT]: 4,
};

export const getTaskPriorityValue = (priority?: TaskPriority): TaskPriority =>
  priority ?? TaskPriority.MEDIUM;

export const getTaskPriorityLabel = (priority?: TaskPriority): string =>
  TASK_PRIORITY_LABELS[getTaskPriorityValue(priority)];

export const getTaskPrioritySortValue = (priority?: TaskPriority): number =>
  TASK_PRIORITY_SORT_ORDER[getTaskPriorityValue(priority)];
